export default __webpack_public_path__ + "static/media/PanetelaOpen.5db71178.jpg";